import {observer} from "mobx-react-lite";
import clubStore from "../../../storage/ClubStore";
import appStore from '../../../storage/AppStore'
import ParentDebts from './ParentDebts'
import {useEffect} from 'react'

const ParentHome = () => {
  useEffect(() => {
    if (clubStore.club.id && clubStore.is_parent) {
      clubStore.parent.getSelf()
    }
  }, [clubStore.club.id])
  if (!clubStore.club?.is_parent) return null;
  return (
    <div className={"mb-5"}>
      <h4 className={"mb-2"}>{appStore.tr.welcome}, {clubStore.parent.self.title}!</h4>
      <ParentDebts/>
    </div>
  );
}
export default observer(ParentHome);